import BaseAPIService from '../base/base-api-service';
import ModelModel from 'src/model/model.model';

class ModelService extends BaseAPIService<ModelModel> {
  public endpoint: string = '/navapp/v1/model';

  constructor() {
    super(ModelModel);
  }

  public getPartModels(
    partNumber: string,
    modelsQty: number
  ): Promise<string[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'get',
      params: {},
      headers: {},
      url: `${this.endpoint}/${partNumber}/models?size=${modelsQty}`
    }).then(res => {
      return res.data;
    });
  }
}

const modelServiceInstance = new ModelService();
Object.freeze(modelServiceInstance);

export default modelServiceInstance;
